module.exports = __webpack_public_path__ + "img/duopingtai.92c8edc2.png";